$bog_merchquarium_number $mol_number
